import { styled, Typography } from "@mui/material";
import { AlertErrorBoundary } from "components/boundary/AlertErrorBoundary";
import { PaddedPaper } from "components/surfaces/PaddedPaper";
import { Suspense } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { useTranslation } from "react-i18next";
import LoadFilterOptions from "./LoadFilterOptions";

export default function SideNavFilter() {
  const { t } = useTranslation();
  return (
    <StyledPaper>
      <Typography variant="h1">{t("label.categories")}</Typography>
      <ErrorBoundary
        FallbackComponent={(props) => <AlertErrorBoundary {...props} />}
      >
        <Suspense>
          <LoadFilterOptions />
        </Suspense>
      </ErrorBoundary>
    </StyledPaper>
  );
}

const StyledPaper = styled(PaddedPaper)`
  display: flex;
  flex-direction: column;
  height: 100%;
  gap: ${({ theme }) => theme.spacing(2)};
`;
